












































import HelloWorld from '@/components/HelloWorld.vue';
import {  Vue } from 'vue-property-decorator';


import VueRouter from 'vue-router';


export default {
    components: { HelloWorld },
    data() {
        return {
            clipped: true,
            drawer: false,
            miniVariant: false,
            right: true,
            title: 'Mobscape LLC',
            items: [
                { title: 'Apps', icon: 'home', link: '/' },
                { title: 'About', icon: 'home', link: '/about' },
                { title: 'Contact', icon: 'home', link: '/contact' },
            ]
        };
    },


    created() {
        //alert(JSON.stringify(this.$route));
    },
   
}
